export class File{
    Content:string;
    FileName:string;
}